// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"91716ae6","142":"0f194912","162":"74fd7e0b","716":"2759aa2d"}[chunkId] + ".chunk.js";
};